<template>
  <div id="app" :style="{direction: cConf.alignRight ? 'rtl' : ''}">
    <router-view></router-view>
    <v-loading v-show="fetchLoading || hardLoading"></v-loading>
  </div>
</template>

<script>
  import {langInfo, getConfig, mallSubmit} from "./api/permission";
  import Loading from "@/components/common/loading";

  export default {
    components: {
      "v-loading": Loading
    },
    data() {
      return {
        cConf: cConf
      }
    },
    computed: {
      fetchLoading() {
        return this.$store.state.detail.fetchLoading;
      },
      hardLoading() {
        return this.$store.state.detail.hardLoading;
      }
    },
    created() {
      this.getLang();
      this.getConfig();
    },
    methods: {
      async getLang() {
        // 语言模板请求
        let lang = await langInfo();
        sessionStorage.setItem('lang', JSON.stringify({cl: sessionStorage.cl, ...lang.data.data}));
      },
      async getConfig() {
        // seo信息请求
        let configData = (await getConfig()).data;
        if (configData && configData.message === 'success') {
          sessionStorage.setItem('configData', JSON.stringify({cl: sessionStorage.cl, ...configData.data}));
          sessionStorage.seo_keywords = configData.data.seo_title;
          sessionStorage.seo_title = configData.data.seo_title;
          sessionStorage.seo_description = configData.data.seo_title;
          sessionStorage.email = configData.data.email;
          document.querySelector('meta[name="keywords"]').setAttribute('content', sessionStorage.seo_keywords);
          document.querySelector('meta[name="description"]').setAttribute('content', sessionStorage.seo_description);
          document.title = sessionStorage.seo_title;
          document.querySelector('meta[property="og:title"]').setAttribute('content', sessionStorage.seo_title);
          document.querySelector('meta[property="og:description"]').setAttribute('content', sessionStorage.seo_description);
          document.querySelector('meta[property="og:url"]').setAttribute('content', window.location.href);
          document.querySelector('meta[property="og:image"]').setAttribute('content', sessionStorage.seo_img);
        }
      },
    }
  };
</script>

<style lang="less">
* {
  box-sizing: border-box;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  font-size:16px;
}

@media screen and (max-width: 340px) {
  html, body{
    font-size:14px;
  }
}

body {
  font-family: '微软雅黑', sans-serif;
  color: #333;
  background: #f3f3f3;
}

body,
dd,
dl,
dt,
fieldset,
form,
h1,
h2,
h3,
h4,
h5,
h6,
html,
img,
legend,
li,
ol,
p,
ul {
  margin: 0;
  padding: 0;
  /*-moz-user-select: none;*/
  /*-webkit-user-select: none;*/
  -webkit-tap-highlight-color: transparent;
}

button,
fieldset,
img,
input {
  border: none;
  padding: 0;
  margin: 0;
  outline-style: none;
}

ul,
li {
  background-color: #ffffff;
}
ol,
ul {
  list-style: none;
}

input {
  padding-top: 0;
  padding-bottom: 0;
}

input,
select {
  vertical-align: middle;
}

input,
select,
textarea {
  font-size: 12px;
  margin: 0;
  font-family: '微软雅黑', sans-serif;
}
textarea {
  resize: none;
}

/*防止拖动*/
img {
  border: 0;
  vertical-align: middle;
}

/*  去掉图片低测默认的3像素空白缝隙*/
table {
  border-collapse: collapse;
}

i {
  font-style: normal;
}

a {
  color: #666;
  text-decoration: none;
}


input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button{
  -webkit-appearance: none !important;
  margin: 0;
}

.mint-msgbox {
  max-width: 640px;
}

.mint-msgbox .mint-msgbox-message {
  font-size: 16px;
  line-height: 24px;
  color: #333;
}

.mint-msgbox .mint-msgbox-message p:first-child {
  margin: 10px 0;
}

.mint-msgbox .mint-msgbox-confirm {
  color: #000;
  font-size: 16px;
}

.mint-msgbox .mint-msgbox-cancel {
  color: #000;
  font-size: 16px;
  border-left: 1px #eee solid;
}

.mint-msgbox .mint-msgbox-confirm:active {
  color: inherit;
}

</style>



// WEBPACK FOOTER //
// src/App.vue